import InternalLink from 'components/UI/InternalLink'
import Svg from 'components/UI/SVG'
import { Flex, Text } from 'theme-ui'
import arrowRightIcon from 'images/right-arrow.svg'

export default function FeatureText({
  icon,
  text,
  subtitle,
  href,
}: {
  icon: React.ElementType
  text: string
  subtitle?: string | null | undefined
  href?: string
}): JSX.Element {
  const Component = href ? InternalLink : Flex

  return (
    <Component
      href={href ?? ''}
      sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
    >
      <Svg svg={icon} />
      <Flex
        sx={{
          gap: '0.8rem',
          alignItems: 'center',
          mt: '1.6rem',
          width: 'fit-content',
        }}
      >
        <Text
          as="h3"
          sx={{
            textAlign: 'center',
          }}
          variant="h3BigBold"
        >
          {text}
        </Text>
        {href && <Svg svg={arrowRightIcon} />}
      </Flex>
      <Text
        sx={{
          textAlign: 'center',
          mt: '0.8rem',
        }}
        variant="paragraphSmallRegular"
      >
        {subtitle}
      </Text>
    </Component>
  )
}
